// @flow
'use strict'

const values_ = require('lodash/values')
const map_ = require('lodash/map')
const pickBy_ = require('lodash/pickBy')
const uniq_ = require('lodash/uniq')

/*::
import typeof { WixDataSchema, WixDataSchemaField, WixDataSchemaFields } from 'wix-data-schema-api'
*/

const hasReferencedCollection = (field /*: WixDataSchemaField */) =>
  !!field.referencedCollection
const getReferencedCollection = (field /*: WixDataSchemaField */) =>
  field.referencedCollection

const _getReferencedCollectionsNames = (
  fields /*: WixDataSchemaFields */
) /*: string[] */ => {
  const referendingFields = pickBy_(fields, hasReferencedCollection)
  const references = values_(referendingFields)
  const referencedCollections = map_(references, getReferencedCollection)
  const uniqueReferencedCollectionsNames = uniq_(referencedCollections)

  return uniqueReferencedCollectionsNames.filter(Boolean)
}

const getReferencedCollectionsNames = (schema /*: WixDataSchema */) => {
  return schema.fields ? _getReferencedCollectionsNames(schema.fields) : null
}

module.exports = getReferencedCollectionsNames



// WEBPACK FOOTER //
// ./schemas/getReferencedCollectionsNames.js